<script>
export default {
  props: {
    extendable: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleClick() {
      this.$emit('extend')
    }
  },

  render() {
    const Header = () => (
      <div style={{ marginBottom: '1rem' }}>
        <el-row
          type="flex"
          gutter={32}
          align="bottom"
          style={{ flexWrap: 'wrap' }}
        >
          <el-col span={null} style={{ flex: '1' }}>
            <h1 style={{ margin: '0' }}>รายการ</h1>
          </el-col>
          {this.extendable && (
            <el-col span={null}>
              <el-button
                type="primary"
                icon="el-icon-plus"
                onClick={this.handleClick}
              >
                ต่อขายฝาก
              </el-button>
            </el-col>
          )}
        </el-row>
      </div>
    )

    const Content = () => (
      <el-card>
        <div>{this.$slots.default}</div>
        {this.$slots.footer && (
          <div style={{ marginTop: '1rem' }}>{this.$slots.footer}</div>
        )}
      </el-card>
    )

    return (
      <div>
        <Header />
        <Content />
      </div>
    )
  }
}
</script>
